import React, { useEffect, useState, useRef } from "react";
import { Modal, ModalBody, Table } from "reactstrap";
import { ContentLoader } from "../../../../components/Common";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import { useTenant } from "../../../../hooks/useTenant";
import EventService from "../../../../services/event_service";
import PrintableExtraEventReport from "./PrintableExtraEventReport";

/**
 * ExtraEventReportModal
 * Relatório de alunos que obtiveram a conquista do evento extra.
 */
const ExtraEventReportModal = ({ isOpen, toggle, event }) => {
    const { idTenant, tenantSettings, tenantName, tenantLogo } = useTenant();
    const printRef = useRef();
    
    const [loading, setLoading] = useState(true);
    const [awards, setAwards] = useState([]);

    const handlePrint = useReactToPrint({
        contentRef: printRef,
        content: () => printRef.current,
        documentTitle: `Relatorio_Evento_Extra_${event?.name || "Evento"}`
    });

    useEffect(() => {
        if (isOpen && event?.id && idTenant) {
            loadAwards();
        } else {
            setAwards([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, event?.id, idTenant]);

    const loadAwards = async () => {
        try {
            setLoading(true);
            const data = await EventService.getExtraEventAwards(idTenant, event.id);
            setAwards(data);
        } catch (error) {
            console.error("Erro ao carregar prêmios do evento", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" scrollable>
            <div className="modal-header border-bottom d-flex align-items-center justify-content-between w-100">
                <div className="d-flex align-items-center gap-2">
                    <i className="mdi mdi-star-circle fs-4 text-warning"></i>
                    <h5 className="modal-title mb-0">Lista de Conquistas - {event?.name}</h5>
                </div>
                <div className="d-flex align-items-center gap-3">
                    <button
                        className="btn btn-primary d-flex align-items-center justify-content-center rounded-2 shadow-sm p-0 border-0"
                        style={{ width: "38px", height: "38px" }}
                        onClick={handlePrint}
                        disabled={loading || awards?.length === 0}
                        title="Imprimir Relatório"
                    >
                        <i className="mdi mdi-printer font-size-18"></i>
                    </button>
                    <button type="button" className="btn-close m-0" onClick={toggle}></button>
                </div>
            </div>
            <ModalBody className="p-4">

                <div className="border-bottom pb-3 mb-4">
                    <div className="text-muted small">
                        <strong>Período:</strong> {event?.startDate ? moment(event.startDate).format("DD/MM/YYYY") : '--'} a {event?.endDate ? moment(event.endDate).format("DD/MM/YYYY") : '--'}
                        <span className="mx-2">|</span>
                        <strong>Categoria:</strong> Evento Extra
                    </div>
                </div>

                {loading ? (
                     <div className="text-center py-5">
                         <ContentLoader message="Carregando relatório..." />
                     </div>
                ) : (
                    <>
                        {awards.length === 0 ? (
                            <div className="alert alert-warning text-center py-4">
                                <i className="mdi mdi-alert-circle-outline fs-3 mb-2 d-block"></i>
                                Não há alunos premiados para este evento ainda.
                            </div>
                        ) : (
                            <>
                                <div className="table-responsive">
                                    <Table striped bordered hover size="sm" className="align-middle mb-0" style={{ backgroundColor: '#fff' }}>
                                        <thead className="table-dark">
                                            <tr>
                                                <th style={{ width: "5%" }} className="text-center">#</th>
                                                <th style={{ width: "35%" }}>Atleta / Aluno</th>
                                                <th>Entregue Em</th>
                                                <th className="text-center">XP Ganha</th>
                                                <th>Entregue Por</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {awards.map((ev, index) => (
                                                <tr key={ev.id || index}>
                                                    <td className="text-center fw-bold text-muted">{index + 1}</td>
                                                    <td className="fw-bold text-dark text-uppercase">{ev.memberName || "Desconhecido"}</td>
                                                    <td className="text-muted small">
                                                        {ev.awardedAt ? moment(ev.awardedAt).format("DD/MM/YYYY") : "-"}
                                                    </td>
                                                    <td className="text-center fw-bold text-success">
                                                        {ev.rewardXp ? `+${ev.rewardXp}` : "-"}
                                                    </td>
                                                    <td className="text-muted small text-uppercase">
                                                        {ev.employeeName || "Sistema"}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>

                                <div className="d-flex justify-content-between align-items-center mt-3 px-2 text-muted small">
                                    <span><strong>Total:</strong> {awards.length} premiações</span>
                                </div>
                            </>
                        )}
                    </>
                )}
            </ModalBody>

            {/* Relatório oculto para impressão */}
            <div style={{ display: "none" }}>
                <div ref={printRef}>
                    <PrintableExtraEventReport
                        awards={awards}
                        event={event}
                        tenantName={tenantName || tenantSettings?.name}
                        tenantLogo={tenantLogo || tenantSettings?.logo}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default ExtraEventReportModal;
